import React, { Component } from "react";
import detector from "detector";
import screenfull from "screenfull";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import socket from "../../socket";

import routing from "../../routing";

import TaskSwitch from "../../components/TaskSwitch";

import Modal from "../../components/Modal";
import Form, { Title, InputText, Submit, InputNumber } from "../../components/Form";

import Seo from "../../../common/helpers/seo";
import { isMobile } from "../../../common/parameters";

import Icons from "../../icons";
import { setItem, hasItem, getItem, removeItem } from "../../cookie";

import Menu from "./Menu";
import { PlayWrapper, ChangeOrientation, KeyPage, KeyPageWrapper, LogoCropper, Privacy } from "./styles";

import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { ICommonTaskProps } from "../../../common/types";
import StudentApplicationAd from "../../components/StudentApplicationAd";

class Join extends Component<IProps, IState> {
    state: IState = {
        key: "",
        taskIndex: 0,
        orientationForceClosed: false,
        nameModal: false,
        name: "",
        validationName: null,
        validationKey: false,
        changeOrientation: false,
        isFullscreen: false,
        paging: false,
        plan: null,
    };
    savedStates: any[] = [];
    saveState?: () => any;
    restoreState?: (state: any) => void;
    showSolution?: () => void;
    handleReset?: () => void;
    componentDidMount() {
        let key = "";
        const { hash } = window.location;
        if (hasItem("join-key")) {
            this.getPlan(getItem("join-key")!);
        } else if (hash && hash.length === 5) {
            key = hash.slice(1);
            this.getPlan(key);
        }
        this.setState({
            key,
            nameModal: false,
            name: "",
            taskIndex: 0,
            plan: null,
        });
        if (detector.os.name !== "ios") {
            document.body.style.overflowY = "hidden";
        }
        if (isMobile) {
            this.checkOrientation();
            window.addEventListener("orientationchange", this.checkOrientation);

            if (screenfull && screenfull.enabled) {
                setTimeout(() => {
                    if (screenfull) {
                        this.setState({ isFullscreen: screenfull.isFullscreen });
                        screenfull.on("change", this.changeFullScreen);
                    }
                }, 200);
            }
        }
        this.savedStates = [];
    }
    changeFullScreen = () => {
        setTimeout(() => {
            if (screenfull) {
                this.setState({ isFullscreen: screenfull.isFullscreen });
            }
        }, 200);
    };

    checkOrientation = () => {
        let landscape = false;
        if (detector.os.name === "ios") {
            if (Math.abs(Number(window.orientation)) === 90) {
                landscape = true;
            } else {
                landscape = false;
            }
        } else {
            if (!window.screen.orientation) {
                this.setState({ changeOrientation: false });
                return;
            } else {
                landscape = window.screen.orientation.type.indexOf("landscape") !== -1;
            }
        }
        setTimeout(() => {
            if (!landscape) {
                this.setState({ changeOrientation: true });
            } else {
                this.setState({ changeOrientation: false });
            }
        });
    };

    componentWillUnmount() {
        socket.com && socket.com.disconnect();
        document.body.style.overflowY = "";
        this.setState({ plan: null });
        window.removeEventListener("orientationchange", this.checkOrientation);
        if (screenfull && screenfull.enabled) {
            screenfull.off("change", this.changeFullScreen);
        }
    }

    getPlan = (key: string) => {
        const { get, changeStudentColors, changeStudentPitchNotation, changeStudentSolfaAudio, changeStudentRhythmSyllableTypes, changeStudentReversedToneset, changeStudentSolfaShort, changeStudentSolfaKam } = this.props;
        get("classroom-plan/" + key, res => {
            const { data } = res;
            if (!data.found) {
                this.setState({ validationKey: true });
                return;
            }

            setItem("join-key", key, 60 * 60);
            changeStudentColors(data.colors);
            changeStudentPitchNotation(data.pitchNotation);
            changeStudentRhythmSyllableTypes(data.rhythmSyllableType);
            changeStudentSolfaAudio(data.solfaAudio);
            changeStudentReversedToneset(data.reversedToneset);
            changeStudentSolfaShort(data.solfaShort);
            changeStudentSolfaKam(data.solfaKam);
            this.setState({ nameModal: true, plan: data.plan });
            this.startSocket(key);
        });
    };

    startSocket(key: string) {
        socket.start();

        socket.com!.on("connect", () => {
            let hasStudentId = hasItem("join-key");
            if (hasStudentId) {
                socket.com!.emit("classroom-student", { key, returning: true, studentId: getItem("student-id") });
            } else {
                socket.com!.emit("classroom-student", { key });
            }
        });
        socket.com!.on("set-student-id", (data: { studentId: string }) => {
            setItem("student-id", data.studentId, 60 * 60);
        });
        socket.com!.on("set-name", (data: { name: string }) => {
            this.setState({ name: data.name, nameModal: false });
        });
        socket.com!.on("go-to", (data: { taskIndex: number }) => {
            if (this.saveState) {
                this.savedStates[this.state.taskIndex] = this.saveState();
            }
            this.setState({ paging: true, taskIndex: data.taskIndex }, () => {
                this.setState({ paging: false }, () => {
                    const { taskIndex } = this.state;
                    if (this.restoreState && this.savedStates[taskIndex]) {
                        setTimeout(() => {
                            this.restoreState!(this.savedStates[taskIndex]);
                        });
                    }
                });
            });
        });

        socket.com!.on("restart-task", (data: { taskIndex: number }) => {
            this.setState({ taskIndex: data.taskIndex }, () => {
                this.handleReset!();
            });
        });

        socket.com!.on("show-solution", (data: { taskIndex: number }) => {
            this.setState({ taskIndex: data.taskIndex }, () => {
                this.showSolution!();
            });
        });

        socket.com!.on("close-classroom", () => {
            removeItem("join-key");
            removeItem("student-id");
            this.props.history.replace("/" + routing.closedClassroom);
        });
    }

    nameChange = (e: React.FormEvent<HTMLInputElement>) => {
        if (e.currentTarget.value.length > 20) return;
        this.setState({ name: e.currentTarget.value, validationName: null });
    };

    setName = () => {
        const { name } = this.state;
        if (name.length === 0) return this.setState({ validationName: "required" });
        if (name.length < 2) return this.setState({ validationName: "tooShortJoinName" });
        socket.com!.emit("set-name", { name });
        this.setState({ nameModal: false });
    };

    completed = (type: string) => {
        if (type !== "flow" && socket.com && socket.com.emit) {
            socket.com.emit("completed");
        }
        this.props.taskCompleted({
            type,
            editor: false,
            planId: this.state.plan!._id,
            page: "join",
            isExperience: false,
        });
    };

    forceClose = () => {
        this.setState({
            orientationForceClosed: true,
        });
    };

    render() {
        const {
            key,
            nameModal,
            name,
            validationName,
            validationKey,
            orientationForceClosed,
            changeOrientation,
            isFullscreen,
            paging,
            taskIndex,
            plan,
        } = this.state;
        const { intl: { formatMessage } } = this.props;
        if (paging) return null;
        const Head = () => <Seo title={formatMessage(messages.classroom)} />;
        if (!plan) {
            return (
                <KeyPage>
                    <Head />
                    <Menu />
                    <KeyPageWrapper>
                        <h1>
                            <FormattedMessage {...messages.classroom} />
                        </h1>
                        <InputNumber
                            name="key"
                            label={<FormattedMessage {...messages.enterKey} />}
                            validation={validationKey ? "incorrectJoinKey" : undefined}
                            value={key}
                            onChange={e => {
                                let key = e.currentTarget.value.slice(0, 4);
                                this.setState({ key, validationKey: false });
                                if (Number(key) > 999) {
                                    this.getPlan(key);
                                }
                            }}
                        />
                        <StudentApplicationAd />
                    </KeyPageWrapper>
                </KeyPage>
            );
        }
        if (taskIndex === null) return <div>Loading...</div>;
        const task = plan.tasks[taskIndex];
        if (!task) return <div>Loading...</div>;
        const Task = TaskSwitch(task.type) as (props: ICommonTaskProps) => JSX.Element;
        return (
            <PlayWrapper>
                <Head />
                <Menu />
                <Task
                    task={task}
                    join
                    completed={this.completed}
                    setReset={f => (this.handleReset = f)}
                    saveState={saveState => (this.saveState = saveState)}
                    restoreState={restoreState => (this.restoreState = restoreState)}
                    showSolution={showSolution => (this.showSolution = showSolution)}
                    plan={plan}
                />
                {nameModal && (
                    <Modal>
                        <Form>
                            <Title>
                                <FormattedMessage {...messages.enterName} />
                            </Title>
                            <InputText
                                validation={validationName}
                                label={<FormattedMessage {...messages.name} />}
                                value={name}
                                onChange={this.nameChange}
                            />
                            <Privacy>
                                <FormattedMessage {...messages.privacyNote} values={{
                                    privacyPolicy: <a className="link" target="_blank" href={`/${routing.privacy}`}>
                                        <FormattedMessage {...messages.privacy} />
                                    </a>
                                }} />
                            </Privacy>
                            <Privacy>
                                <FormattedMessage {...messages.privacyDuration} />
                            </Privacy>
                            <Submit onClick={this.setName}>
                                <FormattedMessage {...messages.submitName} />
                            </Submit>
                        </Form>
                    </Modal>
                )}
                {!nameModal && changeOrientation && (
                    <Modal>
                        <Form>
                            <ChangeOrientation>
                                <FormattedHTMLMessage {...messages.turnDevice} />
                            </ChangeOrientation>
                        </Form>
                    </Modal>
                )}
                {!nameModal &&
                    !changeOrientation &&
                    !isFullscreen &&
                    screenfull &&
                    screenfull.enabled &&
                    isMobile &&
                    !orientationForceClosed && (
                        <Modal close={this.forceClose}>
                            <Form>
                                <ChangeOrientation>
                                    <FormattedMessage {...messages.toFullScreen} />
                                </ChangeOrientation>
                                <Submit onClick={() => {
                                    if (screenfull) {
                                        screenfull.request()
                                    }
                                }}>
                                    <FormattedMessage {...messages.fullScreenButton} />
                                </Submit>
                            </Form>
                        </Modal>
                    )}
            </PlayWrapper>
        );
    }
}

export default Join;
